//
import { ModuleLayout } from '@/components/reusable_components/next'

//
//import { PurchaseTaxDocumentList } from '@/views/treasury/purchase-tax-document'
import TaxDocumentViewList from '@/views/Purchase/PchTaxDocument/PchTaxDocumentList'

//
export default {
    path: 'purchase_tax_documents',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'pch-purchase-tax-document-list',
            component: TaxDocumentViewList,
        },
    ],
    meta: {
        title: 'Documentos de compra',
    },
}

//
export const ContPurchaseDocument = {
    path: 'cont_purchase_documents',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'purchase-tax-document-list',
            component: TaxDocumentViewList,
        },
    ],
    meta: {
        title: 'Documentos de compra',
    },
}
